
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import { GetLaiLoByPhanTramThau, GetTextTienHoi } from "./reportTemplete";
/*
Index 3 : Mẫu 3 Bình tân
Thứ…, ngày… Khách
Tên khách
MN: 2C…da…dx… 3C…4C… (tiền qua cò)
Trúng: 2C… da…dx…3C…4C…(tiền trúng)
(Nếu là chuyển cho Chủ)
Thu = Lãi hay Bù = Lỗ * 0.95
(Nếu là nhận của khách)
Thu = Lãi * 0.95 hay Bù = Lỗ
*/
type groupItemList = `2CDA` | `3C4C` | `XMB`;
export const templeteBinhTan_details: { [key: string]: groupItemList } = {
    "6Lo2c": "2CDA",
    "DKC": "2CDA",
    '6Lo3C': '3C4C',
    '7Lo2C': '2CDA',
    '8Lo2C': '2CDA',
    '7Lo3C': '3C4C',
    'DaT': '2CDA',
    'Dau2C': '2CDA',
    'Dau4C': '3C4C',
    'DaX': '2CDA',
    'Duoi2C': '2CDA',
    'Duoi4C': '2CDA',
    'Lo2C': '2CDA',
    'Lo3C': '3C4C',
    'Lo4C': '3C4C',
    'XC': '3C4C',
    'XcDau': '3C4C',
    'XcDuoi': '3C4C',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
export const templeteBinhTan_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        '2CDA': 0,
        '3C4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    Xac: {
        '2CDA': 0,
        '3C4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    //Qua cò
    TienTrung: {
        '2C': 0,
        '3C': 0,
        '4C': 0,
        'da': 0,
        'dx': 0,
        'XMB': 0,
    } as { [key: string]: number },
    GetLaiLo: function () {
        return this.QuaCo['2CDA'] + this.QuaCo['3C4C'] + this.QuaCo['XMB']
            - (this.TienTrung['2C'] + this.TienTrung['3C'] + this.TienTrung['4C']
                + this.TienTrung['da'] + this.TienTrung['dx'] + this.TienTrung['XMB'])
    },
    GetSMS: function () {
        let sms = "";// "Ngay:" + this.NGAY + "\r\n"
        sms += this.MIEN + ":"
        if (this.QuaCo['2CDA'] != 0) {
            sms += `2c+da:${tienFormat(this.Xac['2CDA'], 1)}=`
            sms += `${tienFormat(this.QuaCo['2CDA'], 1)}n\r\n`
        }
        if (this.QuaCo['3C4C'] != 0) {
            sms += `3c+4c:${tienFormat(this.Xac['3C4C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['3C4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB:${tienFormat(this.Xac['XMB'], 1)}`
            sms += `${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }
        //tien thuong
        let tmp = ""
        if (this.TienTrung['2C'] != 0) {
            tmp += `2c=${tienFormat(this.TienTrung['2C'], 1)}n\r\n`
        }
        if (this.TienTrung['da'] != 0) {
            tmp += `da=${tienFormat(this.TienTrung['da'], 1)}n\r\n`
        }
        if (this.TienTrung['dx'] != 0) {
            tmp += `dx=${tienFormat(this.TienTrung['dx'], 1)}n\r\n`
        }
        if (this.TienTrung['3C']! + 0) {
            tmp += `3c=${tienFormat(this.TienTrung['3C'], 1)}n\r\n`
        }
        if (this.TienTrung['4C'] != 0) {
            tmp += `4c=${tienFormat(this.TienTrung['4C'], 1)}n\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB=${tienFormat(this.TienTrung['XMB'], 1)}n\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        const laiSauPhanTram = laiLo / 100 * (100 - this.message.phanTramThau)
        const hoiSauPhanTram = this.message.tienHoi / 100 * (100 - this.message.phanTramThau)
        if (laiLo > 0) {
            sms += "\r\nThu:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiSauPhanTram, hoiSauPhanTram)
        } else if (laiLo < 0) {
            sms += "\r\nBù:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiSauPhanTram, hoiSauPhanTram)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function getSMSMauBinhTan(messages1: any) {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templeteBinhTan_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templeteBinhTan_total = _.cloneDeep(templeteBinhTan_total);
        curSms.message = msg
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau;
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templeteBinhTan_details[loaiCuocId];
                curSms.QuaCo[groupId] += item.quaCo;
                curSms.Xac[groupId] += item.xac;
                switch (loaiCuocId) {
                    case "6Lo2c":
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case "DKC":
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case '6Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case '7Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case '8Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case '7Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case 'DaT':
                        curSms.TienTrung["da"] += item.thuong
                        break;
                    case 'Dau2C':
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case 'Dau4C':
                        curSms.TienTrung["4C"] += item.thuong
                        break;
                    case 'DaX':
                        curSms.TienTrung["dx"] += item.thuong
                        break;
                    case 'Duoi2C':
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case 'Duoi4C':
                        curSms.TienTrung["4C"] += item.thuong
                        break;
                    case 'Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        break;
                    case 'Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case 'Lo4C':
                        curSms.TienTrung["4C"] += item.thuong
                        break;
                    case 'XC':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case 'XcDau':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case 'XcDuoi':
                        curSms.TienTrung["3C"] += item.thuong
                        break;
                    case 'Xi2':
                        curSms.TienTrung["XMB"] += item.thuong
                        break;
                    case 'Xi3':
                        curSms.TienTrung["XMB"] += item.thuong
                        break;
                    case 'Xi4':
                        curSms.TienTrung["XMB"] += item.thuong
                        break;
                    default:
                        console.log('Bổ xung loại cược mới', loaiCuocId)
                }

            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoi = 0;
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoi += sms.message.tienHoi
    })
    tienHoi = tienHoi / 100 * (100 - phanTramThau)
    const laiSauPhanTram = laiLo / 100 * (100 - phanTramThau)
    if (messages.length > 1) {
        if (laiLo > 0) {
            zSms += "\r\nTổng cộng thu:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiSauPhanTram, tienHoi)
        } else if (laiLo < 0) {
            zSms += "\r\nTổng cộng bù:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiSauPhanTram, tienHoi)
        } else {
            zSms += "\r\nTổng cộng hoà"
        }
    }
    console.log(zSms)
    return zSms;
}